import { render, staticRenderFns } from "./PopupAddAssessment.vue?vue&type=template&id=62482f20&scoped=true&"
import script from "./PopupAddAssessment.vue?vue&type=script&lang=js&"
export * from "./PopupAddAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PopupAddAssessment.vue?vue&type=style&index=0&id=62482f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62482f20",
  null
  
)

export default component.exports